import _ from 'lodash'

const B_TV_MASONRY_CONFIG = {
    section: _.select( '.c-section--tv-solutions-masonry' ),
    headlands: _.selectAll( '.c-section--tv-solutions-masonry .headland__trigger' ),
    chapters: _.selectAll( '.c-section--tv-solutions-masonry .chapter__trigger' )
}

export default B_TV_MASONRY_CONFIG